import React, { useState, useContext, useEffect } from 'react';
import '../../Booking.css';
import { StateContext } from '../../../../StateProvider';
import { FaInfoCircle } from 'react-icons/fa';
import Calendar from 'react-calendar';
import { tooltips } from './groomingTooltips';
import GroomingOptions from './GroomingOptions';
import { getGroomingAvailabilityByMonth } from '../../../../Utilities/api';
import { Carousel as BootstrapCarousel } from 'react-bootstrap';
import TimeSlots from '../../../../Utilities/components/TimeSlots';

import groomingBanner1 from '../../../../../assets/Store/Services/Daycare/groomingBanner1.png';
import groomingBanner2 from '../../../../../assets/Store/Services/Daycare/groomingBanner2.png';
import daycareBanner2 from '../../../../../assets/Store/Services/Daycare/daycareBanner2.png';
import daycareBanner1 from '../../../../../assets/Store/Services/Daycare/daycareBanner1.png';

function GroomingBooking() {
  const ctx = useContext(StateContext);
  const user = ctx && ctx.user ? ctx.user : null;
  const setBookingData = ctx && ctx.setBookingData ? ctx.setBookingData : function(){};

  const [isGroomingOptionsOpen, setIsGroomingOptionsOpen] = useState(false);
  const [selectedPetForGrooming, setSelectedPetForGrooming] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [datesSelected, setDatesSelected] = useState(false);
  const [availabilityCache, setAvailabilityCache] = useState({});
  const [tooltipVisibility, setTooltipVisibility] = useState({
    petSelection: false,
    appointmentDate: false,
    groomingPreferences: false,
  });

  const [groomingBookingData, setGroomingBookingData] = useState({
    selectedPets: [],
    dateRange: null,
    showCalendar: false,
    foodPreference: '',
    specialNotes: '',
    pickupTime: '',
    dropoffTime: '',
    groomingOptions: [],
    trainingOptions: [],
    selectedPackage: '',
    additionalServices: {
      hotel: false,
      daycare: false,
      grooming: false,
      training: false,
      shuttle: false,
      adventure: false,
      walk: false
    }
  });

  useEffect(function () {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const year = today.getFullYear();
    const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
    const nextMonthYear = currentMonth === 12 ? year + 1 : year;

    const currentMonthKey = year + '-' + currentMonth;
    const nextMonthKey = nextMonthYear + '-' + nextMonth;

    async function fetchAvailability() {
      const needCurrent = !availabilityCache[currentMonthKey];
      const needNext = !availabilityCache[nextMonthKey];

      let currentMonthData = null;
      let nextMonthData = null;

      if (needCurrent) {
        try { currentMonthData = await getGroomingAvailabilityByMonth(currentMonth, year); } catch (e) {}
      }
      if (needNext) {
        try { nextMonthData = await getGroomingAvailabilityByMonth(nextMonth, nextMonthYear); } catch (e) {}
      }

      setAvailabilityCache(function(prev){
        const next = Object.assign({}, prev);
        if (currentMonthData) next[currentMonthKey] = currentMonthData;
        if (nextMonthData) next[nextMonthKey] = nextMonthData;
        return next;
      });
    }

    fetchAvailability();

    setBookingData(function(prevData){
      const next = Object.assign({}, prevData || {});
      next.bookingInfo = groomingBookingData;
      return next;
    });
  }, [groomingBookingData]);

  const handleActiveStartDateChange = function ({ activeStartDate }) {
    const month = activeStartDate.getMonth();
    const year = activeStartDate.getFullYear();

    const keysToFetch = [];
    keysToFetch.push(year + '-' + (month + 1));

    const nextMonth = (month + 1) % 12;
    const nextMonthYear = month === 11 ? year + 1 : year;
    keysToFetch.push(nextMonthYear + '-' + (nextMonth + 1));

    for (let i = 0; i < keysToFetch.length; i++) {
      const key = keysToFetch[i];
      if (!availabilityCache[key]) {
        const parts = key.split('-');
        const fetchYear = parseInt(parts[0], 10);
        const fetchMonth = parseInt(parts[1], 10);

        getGroomingAvailabilityByMonth(fetchMonth, fetchYear)
          .then(function(data){
            setAvailabilityCache(function(prev){
              const n = Object.assign({}, prev);
              n[key] = data;
              return n;
            });
          })
          .catch(function(err){
            try { console.error('Failed to fetch booking data for ' + key + ':', err); } catch(e){}
          });
      }
    }
  };

  const tileDisabled = function ({ date, view }) {
    if (view === 'month') {
      const today = new Date();
      today.setHours(0,0,0,0);
      if (date < today) return true;

      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const key = year + '-' + month;

      const monthData = availabilityCache[key] ? availabilityCache[key] : null;
      if (monthData && Array.isArray(monthData.dailyAvailability)) {
        const idx = day - 1;
        if (idx >= 0 && idx < monthData.dailyAvailability.length) {
          return monthData.dailyAvailability[idx] <= 0;
        }
      }
      return false;
    }
    return false;
  };

  const showTooltip = function (key) {
    const next = Object.assign({}, tooltipVisibility);
    next[key] = true;
    setTooltipVisibility(next);
  };

  const hideTooltip = function (key) {
    const next = Object.assign({}, tooltipVisibility);
    next[key] = false;
    setTooltipVisibility(next);
  };

  // Single pet selection; also store petType in selectedPets for downstream logic
  const togglePetSelection = function (pet) {
    setGroomingBookingData(function(prevBookingData){
      let alreadySelected = false;
      let i = 0;
      while (i < prevBookingData.selectedPets.length) {
        const p = prevBookingData.selectedPets[i];
        if (p && p.petId === pet.id) { alreadySelected = true; break; }
        i++;
      }

      if (alreadySelected) {
        setSelectedPetForGrooming(null);
        setIsGroomingOptionsOpen(false);
        return Object.assign({}, prevBookingData, { selectedPets: [], groomingOptions: [] });
      } else {
        const newSelectedPet = { petId: pet.id, petName: pet.name, petType: pet.type };
        setSelectedPetForGrooming(pet);
        setIsGroomingOptionsOpen(true);
        return Object.assign({}, prevBookingData, { selectedPets: [newSelectedPet], groomingOptions: [] });
      }
    });
  };

  const handleDateChange = function (date) {
    let selectedDate = date;
    if (Array.isArray(date)) selectedDate = date[0];

    if (!(selectedDate instanceof Date) || isNaN(selectedDate)) {
      try { console.error('Invalid date selected:', selectedDate); } catch(e){}
      return;
    }

    const formattedDate = [selectedDate, selectedDate];
    setShowCalendar(false);
    setDatesSelected(true);

    const day = selectedDate.getDate();
    const month = selectedDate.getMonth() + 1;
    const year = selectedDate.getFullYear();
    const key = year + '-' + month;

    let dayAvailability = [];

    // ✅ IMPORTANT: backend returns OBJECT keyed by day number
    if (
      availabilityCache[key] &&
      availabilityCache[key].dailyAvailability &&
      availabilityCache[key].dailyAvailability[day]
    ) {
      dayAvailability = availabilityCache[key].dailyAvailability[day];
    }

    if (!Array.isArray(dayAvailability)) {
      dayAvailability = [];
    }

    const now = new Date();

    const isSameDay =
      selectedDate.getFullYear() === now.getFullYear() &&
      selectedDate.getMonth() === now.getMonth() &&
      selectedDate.getDate() === now.getDate();

    // ✅ SAME-DAY RULE: remove past times ONLY
    const filteredSlots = isSameDay
      ? dayAvailability.filter(function(slot){
          const slotDate = new Date(slot);
          return slotDate > now;
        })
      : dayAvailability;

    setGroomingBookingData(function(prev){
      const next = Object.assign({}, prev);
      next.dateRange = formattedDate;
      next.availableTimeSlots = filteredSlots;
      return next;
    });
  };

  const handleTimeChange = function (timeType, time) {
    setGroomingBookingData(function(prevData){
      const next = Object.assign({}, prevData);
      next[timeType] = time;
      return next;
    });
  };

  const handleNotesChange = function (e) {
    const val = e && e.target ? e.target.value : '';
    setGroomingBookingData(function(prevData){
      const next = Object.assign({}, prevData);
      next.specialNotes = val;
      return next;
    });
  };

  const handleServiceChange = function (serviceName) {
    const currentStatus = groomingBookingData.additionalServices[serviceName];
    const updatedServices = Object.assign({}, groomingBookingData.additionalServices);
    updatedServices[serviceName] = !currentStatus;

    setGroomingBookingData(function(prevData){
      const next = Object.assign({}, prevData);
      next.additionalServices = updatedServices;
      return next;
    });
  };

  return (
    <div className='booking-backdrop'>
      <section className="store-banner-section">
        <BootstrapCarousel fade controls={false} indicators={false} interval={3000}>
            <BootstrapCarousel.Item>
                <img className="d-block w-100" src={groomingBanner2} alt="Hero 1" />
            </BootstrapCarousel.Item>
            <BootstrapCarousel.Item>
                <img className="d-block w-100" src={groomingBanner1} alt="Hero 2" />
            </BootstrapCarousel.Item>
            <BootstrapCarousel.Item>
                <img className="d-block w-100" src={daycareBanner2} alt="Hero 3" />
            </BootstrapCarousel.Item>
            <BootstrapCarousel.Item>
                <img className="d-block w-100" src={daycareBanner1} alt="Hero 3" />
            </BootstrapCarousel.Item>
        </BootstrapCarousel>
      </section>

      <div className="booking-container">
        <div className="booking-header">
          <h3>Pawsible Grooming</h3>
        </div>

        <div className="booking-content">
          <div className="booking-section">
            <h2>
              Pet Guests <FaInfoCircle onMouseOver={function(){showTooltip('who');}} onMouseOut={function(){hideTooltip('who');}} />
            </h2>
            {tooltipVisibility.who ? <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.who }}></div> : null}
            <div className="pet-selection">
              {user && user.familyMembers ? user.familyMembers.map(function(pet){
                if (pet && (pet.type === 'Dog' || pet.type === 'Cat')) {
                  const isSelected = groomingBookingData.selectedPets.length > 0 &&
                                     groomingBookingData.selectedPets[0] &&
                                     groomingBookingData.selectedPets[0].petId === pet.id;
                  return (
                    <div key={pet.id}>
                      <button
                        className={'pet-button-' + (isSelected ? 'selected' : '')}
                        onClick={function(){ togglePetSelection(pet); }}
                      >
                        <img src={pet.image} alt={pet.name} className="pet-photo" />
                        <p className='pet-name'>{pet.name}</p>
                        <p className='pet-type'>{pet.type}</p>
                      </button>
                    </div>
                  );
                }
                return null;
              }) : null}
            </div>
          </div>

          <div className={'booking-section-selectedPetForGrooming ' + (isGroomingOptionsOpen ? 'open' : 'close')}>
            {selectedPetForGrooming ? (
              <div>
                <GroomingOptions
                  selectedPetForGrooming={selectedPetForGrooming}
                  groomingBookingData={groomingBookingData}
                  setGroomingBookingData={setGroomingBookingData}
                />
              </div>
            ) : null}
          </div>

          <div className="booking-section">
            <h2>Date <FaInfoCircle onMouseOver={function(){showTooltip('when');}} onMouseOut={function(){hideTooltip('when');}} /></h2>
            {tooltipVisibility.when ? <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.when }}></div> : null}
            <button
              onClick={function(){ setShowCalendar(!showCalendar); }}
              className={datesSelected ? 'calendar-button-selected' : 'calendar-button'}
            >
              {groomingBookingData.dateRange ? groomingBookingData.dateRange[0].toLocaleDateString() : 'Select Date'}
            </button>
            {showCalendar ? (
              <div className='booking-calendar-container'>
                <div className="legend">
                  <div className="legend-item"><span className="history-dot" />Full</div>
                  <div className="legend-item"><span className="today-dot" />Today</div>
                  <div className="legend-item"><span className="booked-dot" />Active</div>
                  <div className="legend-item"><span className="events-dot" />Events</div>
                </div>
                <Calendar
                  selectRange={false}
                  calendarType="gregory"
                  value={groomingBookingData.dateRange}
                  onChange={handleDateChange}
                  onActiveStartDateChange={handleActiveStartDateChange}
                  tileDisabled={tileDisabled}
                />
              </div>
            ) : null}
          </div>

          <div className="booking-section">
            {groomingBookingData.availableTimeSlots && groomingBookingData.availableTimeSlots.length > 0 ? (
              <div>
                <h2>Time <FaInfoCircle onMouseOver={function(){showTooltip('times');}} onMouseOut={function(){hideTooltip('times');}} /></h2>
                {tooltipVisibility.times ? <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.times }}></div> : null}
                <TimeSlots
                  type="grooming"
                  timeSlotsData={groomingBookingData.availableTimeSlots}
                  handleTimeChange={handleTimeChange}
                  selectedTimeSlot={groomingBookingData.selectedTimeSlot}
                />
              </div>
            ) : null}
          </div>

          {/* <div className="booking-section">
            <div className='additional-services'>
              <h2>Additional Services <FaInfoCircle onMouseOver={function(){showTooltip('services');}} onMouseOut={function(){hideTooltip('services');}} /></h2>
              {tooltipVisibility.services ? <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.services }}></div> : null}
              <div className='booking-additional-button-container grooming'>
                <button className={'service-button-' + (groomingBookingData.additionalServices.hotel ? 'selected' : '')} onClick={function(){ handleServiceChange('hotel'); }}>Hotel</button>
                <button className={'service-button-' + (groomingBookingData.additionalServices.daycare ? 'selected' : '')} onClick={function(){ handleServiceChange('daycare'); }}>Daycare</button>
                <button className={'service-button-' + (groomingBookingData.additionalServices.training ? 'selected' : '')} onClick={function(){ handleServiceChange('training'); }}>Training</button>
                <button className={'service-button-' + (groomingBookingData.additionalServices.shuttle ? 'selected' : '')} onClick={function(){ handleServiceChange('shuttle'); }}>Shuttle</button>
                <button className={'service-button-' + (groomingBookingData.additionalServices.adventure ? 'selected' : '')} onClick={function(){ handleServiceChange('adventure'); }}>Adventure</button>
                <button className={'service-button-' + (groomingBookingData.additionalServices.walk ? 'selected' : '')} onClick={function(){ handleServiceChange('walk'); }}>Leash Walk</button>
              </div>
            </div>
          </div> */}

          <div className="booking-section">
            <h2>
              Special Requests <FaInfoCircle onMouseOver={function(){showTooltip('groomingPreferences');}} onMouseOut={function(){hideTooltip('groomingPreferences');}} />
            </h2>
            {tooltipVisibility.groomingPreferences ? <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.groomingPreferences }}></div> : null}
            <textarea
              placeholder="Tell us here!"
              value={groomingBookingData.specialNotes}
              onChange={handleNotesChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroomingBooking;
